import { render } from "./ContractPackages.vue?vue&type=template&id=44d69a17&scoped=true"
import script from "./ContractPackages.vue?vue&type=script&lang=js"
export * from "./ContractPackages.vue?vue&type=script&lang=js"

import "./ContractPackages.vue?vue&type=style&index=0&id=44d69a17&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d69a17"]])

export default __exports__